import { useSelector } from 'react-redux';

const useUserGroupsDropdown = ({ category }) => {
  const { readStatus, results } = useSelector(({ userGroups: { userGroups } }) => userGroups[category]);
  return { readStatus, groups: results };
};

export default {
  useUserGroupsDropdown,
};
